module.exports = __webpack_public_path__ + "static/media/development_04@2x.3d96f3b3.png";